

// ROLE PERMISSIONS
export const GET_ROLE_PERMISSIONS = "/role-permissions";
export const ADD_NEW_ROLE_PERMISSION = "/role-permissions";
export const UPDATE_ROLE_PERMISSION = "/role-permissions";
export const DELETE_ROLE_PERMISSION = "/role-permissions";
